import {Component, Input, OnInit} from '@angular/core';
import {MdAvailabilityService} from '../../../services/mdAvailability.service';
import {escapeHtml, ServiceMapPopup, serviceMapBlock, serviceMapRow} from '../service-map/service-map.component';

@Component({
  selector: 'apcol-md-service-map',
  templateUrl: './md-service-map.component.html'
})
export class MdServiceMapComponent implements OnInit {

  @Input() commercialPopList = [];
  marketsList: { [trigram: string]: string[] } = {};
  loading = true;
  error = false;

  constructor(private mdAvailabilityService: MdAvailabilityService) {
  }

  ngOnInit() {
    this.mdAvailabilityService.getMdAvailabilitiesForMap().subscribe({
      next: res => {
        this.marketsList = res as any;
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      }
    });
  }

  buildPopup = (pop: any, entry: string[]): ServiceMapPopup => {
    const markets = entry || [];
    const blocks = markets.map(market => {
      const separator = market.indexOf(': ');
      const name = separator === -1 ? market : market.substring(0, separator);
      const options = separator === -1 ? '' : market.substring(separator + 2);
      return serviceMapBlock(name, [serviceMapRow('', escapeHtml(options) || '&mdash;')]);
    });

    return {
      count: markets.length,
      countLabel: 'market',
      body: blocks.join('')
    };
  }
}
